var AWS_TEMPLATE = "{signingService}.{region}.amazonaws.com";
export var getHostnameTemplate = function (signingService, _a) {
    var partitionHostname = _a.partitionHostname;
    return partitionHostname !== null && partitionHostname !== void 0 ? partitionHostname : AWS_TEMPLATE.replace("{signingService}", signingService);
};
